module.exports = __webpack_public_path__ + "media/images/pages/img_digest_facility_01-542e710e0e22e9ddc5082d2ed17dcbf1.jpg";